import styled from '@emotion/styled';

import { RequiredMark } from './RequiredMark';

import type { FunctionComponent, ReactNode } from 'react';

const LabelContainer = styled.div({
    display: 'flex',
    marginBottom: '0.5rem',
});

const LabelText = styled.span({
    color: '#040f16',
    fontFamily: 'FT Regola Neue',
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: '1.25rem',
    wordWrap: 'break-word',
});

type RequiredSectionTitleProps = {
    readonly children: ReactNode;
    readonly required?: boolean;
};

export const RequiredSectionTitle: FunctionComponent<RequiredSectionTitleProps> = ({ children, required = false }) => {
    return (
        <LabelContainer>
            <LabelText>{children}</LabelText>
            {required && <RequiredMark />}
        </LabelContainer>
    );
};
